import React, { Fragment, Component } from 'react';
import { withRouter } from 'react-router';
import { withSnackbar } from 'notistack';
import moment from 'moment';
import { Button, Grid, TextField, Tooltip,  Drawer, CircularProgress } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import AddIcon from '@material-ui/icons/Add';
import CloseIcon from '@material-ui/icons/Close';
import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { addEditObligationApi, getObligationApi } from '../apiServices';
import { LabelValueCard, RevisionHistory, PageLoader, CustomChip, CustomDropzone, PreviewDocsModal, DeletePopUp } from '../../../../shared_elements';
import { fieldDateFormat, backendDateFormat, displayDateFormat, assetId } from '../../../../constants';
import { capitalizeFirstLetter, checkApiStatus,  checkPermission, toastFlashMessage } from '../../../../utils_v2';
import { fieldValidation } from '../../../../utils_v2/formValidation';
import { errorCode, addObligation } from '../';
import { regexConstants } from '../../../../constants/regEx';
import { jetStreamInstance } from '../../../Leases';
import { avationPlcInstance, titanInstance, mtInstance, leshaBankInstance } from '../../../../shared_elements/components';
import { globalPostService } from '../../../../utils_v2/globalApiServices';
import { addAttachmentApi, deleteAttachmentApi } from '../../../../shared_elements/apiServices';
class ObligationCRU extends Component{
  constructor(props){
    super(props);
    this.state = {
      modal:false,
      mode:'',
      formSubmitLoader:false,
      pageLoader: false,
      obligation: {},
      error:{},
      previewDocs: '',
      deleteAttachmentModal: false, 
      deleteItem: null,
      attachedDoc:[],
    }
    this.addEditObligationApi = addEditObligationApi.bind(this);
    this.getObligationApi = getObligationApi.bind(this);
  }
  onFieldChange = (event, keyParam, data) => {
    this.updateFormField(keyParam, data);
    if(keyParam === 'sub_type' && data && data.value === 2){
      this.updateFormField('value', '');
      this.updateFormField('payment_due_date', null);
    }
  }
  updateFormField = (key, value) => {
    if (key === 'copies' || key === 'guarantor' || key === 'frequency' || key === 'required' || key=== "last_financial_record") {
      this.setState(prevState => ({
        obligation: {
          ...prevState.obligation,
          titan_extra_fields: {
            ...prevState.obligation?.titan_extra_fields,
            [key]: value,
          },
        },
      }));
    }else{
    this.setState(prevState => ({
      ...prevState,
      obligation: {
        ...prevState.obligation,
        [key]:value
      }
    }))
  }
  }
  updateErrorField = (key, message) => {
    this.setState(prevState => ({
      ...prevState,
      error: {
        ...prevState.error,
        [key]:message
      }
    }))
  }

  getDeleteResponse = () => {
    const { obligation, deleteItem } = this.state
    const updatedAttachments = obligation?.attachments?.filter(
      attachment => attachment.uuid !== deleteItem?.uuid
    );
    this.setState(prevState => ({
      ...prevState,
      obligation: {
        ...prevState.obligation,
        attachments: updatedAttachments
      }
    }))
    this.props.getResponseBack()
  }

  toggleFnc = (key,status)=>{
    this.setState({[key] : status})
  }

  addEditObligationFn = () => {
    const {obligation} = this.state;
    let validationInputs = {
      obligation_type:errorCode['obligation_type'][fieldValidation({...errorCode['obligation_typeObj'], fieldval: obligation.obligation_type && obligation.obligation_type.value ? obligation.obligation_type.value.toString():'' })],
      sub_type:[1,2,3,4].includes(obligation?.obligation_type?.value)?errorCode['sub_type'][fieldValidation({...errorCode['sub_typeObj'], fieldval: obligation.sub_type && obligation.sub_type.value ? obligation.sub_type.value.toString():''})]:'',
      value: [1,2,3,4].includes(obligation?.obligation_type?.value)?obligation.sub_type && obligation.sub_type.value !== 2 ? errorCode['value'][fieldValidation({...errorCode['valueObj'], fieldval: obligation.value})]:'':'',
      // details:errorCode['details'][fieldValidation({...errorCode['detailsObj'], fieldval: obligation.details})],
      applicable:[1,2,3,4].includes(obligation?.obligation_type?.value)&&!leshaBankInstance?errorCode['applicable'][fieldValidation({...errorCode['applicableObj'], fieldval: obligation.applicable})]:'',
      to_be_approved_by:[1,2,3,4].includes(obligation?.obligation_type?.value)?errorCode['to_be_approved_by'][fieldValidation({...errorCode['to_be_approved_byObj'], fieldval: obligation.to_be_approved_by})]:'',
      payment_due_date:[1,2,3,4].includes(obligation?.obligation_type?.value)? (obligation.sub_type && obligation.sub_type.value !== 2 ? errorCode['payment_due_date'][fieldValidation({...errorCode['payment_due_dateObj'], fieldval: obligation.payment_due_date})]:''):'',
      frequency: [5,6,7,8].includes(obligation?.obligation_type?.value)?errorCode['frequency'][fieldValidation({...errorCode['frequencyObj'], fieldval: obligation?.titan_extra_fields?.frequency})]:'',
    };
    if(Object.keys(validationInputs).every((k) => { return validationInputs[k] === ''})){
      if (this.state.attachedDoc?.length+ obligation?.attachments?.length>50) {
        this.props.enqueueSnackbar('Only 50 attachment can be attached.', { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
        return; 
      }
      this.setState({formSubmitLoader:true});
      let payload = Object.assign({}, obligation);
      payload = {
        ...payload,
        obligation_type:obligation.obligation_type.value,
        sub_type:obligation.sub_type?obligation.sub_type.value:null,
        to_be_approved_by:obligation.to_be_approved_by?obligation.to_be_approved_by.id:null
      }
      if(obligation.created_by && obligation.created_by.id !==""){
        payload = {
          ...payload,
          created_by:obligation.created_by.id,
          status:obligation.status?obligation.status?.value:'0',
        }
      }
      if([5,6,7,8].includes(obligation?.obligation_type?.value)&& !obligation.to_be_approved_by){
        payload = {
          ...payload,
          status:null,
        }
      }
      if(titanInstance && obligation?.obligation_type?.value === 5){
        payload ={
          ...payload,
          last_financial_record : obligation?.titan_extra_fields?.last_financial_record ?obligation?.titan_extra_fields?.last_financial_record  :null
        }
      }
      this.addEditObligationApi(this.props, payload)
      .then(response => {
        this.setState({formSubmitLoader:false});
        if(checkApiStatus(response)){
          this.setState({modal:false, mode:'', obligation:{}, error:{}});
          if (this.state.attachedDoc?.length > 0) {
            addAttachmentApi(response?.data, this.props, this.state.attachedDoc, "15", this.toggleFnc);
          } else {
            this.props.enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
            this.props.getResponseBack();
          }
        }else{
          this.props.enqueueSnackbar(response.data.message, {variant: 'error', anchorOrigin:{vertical: 'top',horizontal: 'right'}});
        }
      })
    }else{
      this.setState({error:validationInputs});
    }
  }


  handleDelete = (item) => {
    this.setState({ deleteAttachmentModal: true, deleteItem: item });
  };
  render(){
    const { modal, mode, formSubmitLoader, obligation, error, pageLoader } = this.state;
    const { id, m, pltConstants, approvedUser, contractInfo, readmore } = this.props;
    return(
      <Fragment>
        { pageLoader ? <PageLoader />:null }
        { id && !readmore ?
          <span onClick={() => this.getObligationApi(this.props, id, m)}><Tooltip title="View"><VisibilityIcon color='primary' fontSize='small' style={{cursor:'pointer'}}/></Tooltip></span>
          : readmore ?<span style={{color:"#2a9ccc", cursor:'pointer'}} onClick={() => this.getObligationApi(this.props, id, m)}> ...more</span>:
          contractInfo?.hdlineInfo?.archived_asset == false?
          <Button onClick={() => this.setState({modal:true, leaseOption:addObligation, mode:'add'})} variant="contained" color="primary"><AddIcon fontSize='small'/>Add Obligation</Button>
          :null}
        { modal ?
          <Drawer
            open={modal}
            anchor="right"
            onClose={() => this.setState({modal:false, mode:'', obligation:{}, error:{}})}
          >
            <div style={{width:'670px'}} className="drawer-container">
              <div className="drawer-header" alignItems='center'>
                <span className="left-blk">{`${capitalizeFirstLetter(mode)} Obligation`}</span>
                <CloseIcon className="close-icon" onClick={()=> this.setState({modal:false})}/>
                { mode !== 'add' ?
                  <ul className="list-inline right-blk">
                    <li className="list-inline-item">
                      <RevisionHistory
                        url='audit/contracts/ctobligations/'
                        queryParams={{action:1, object_id:id}}
                        buttonType={false}
                      />
                    </li>
                    <li className="list-inline-item">
                      { contractInfo?.hdlineInfo?.archived_asset == false? checkPermission('contracts','obligations', 'U') && mode === 'view' && <span className="cta" onClick={() => this.setState({mode:'edit'})}><EditIcon className="edit-icon"/>Edit</span>: null}
                      {mode !== 'view' && <span className="cta" onClick={() => this.setState({mode:'view'})}><VisibilityIcon className="view-icon"/>View</span>}
                    </li>
                  </ul>:null
                }
              </div>
              <div className="drawer-body" style={{position : "sticky"}}>
                <Grid container spacing={3}>
                  { mode === 'view' ?
                    <LabelValueCard md={6} label='Type' value={obligation.obligation_type && obligation.obligation_type.label ? obligation.obligation_type.label:'--'} /> :
                    <Grid item xs={12} md={6}>
                      <Autocomplete
                        options = {pltConstants.filter(item => item.type === 'obligation_type' && (titanInstance||avationPlcInstance|| mtInstance || leshaBankInstance || (item.value !== 5 && item.value !== 6 && item.value !== 7 && item.value !==8)))}
                        getOptionLabel={option => option.label}
                        id="obligation_type"
                        value={obligation.obligation_type ? obligation.obligation_type:null}
                        onChange={(e, value) => {this.onFieldChange(e, 'obligation_type', value);}}
                        renderInput={params => <TextField required error={error.obligation_type ? true:false} helperText={error.obligation_type?error.obligation_type:''} onFocus={(e) => this.updateErrorField('obligation_type')} {...params} label="Type" placeholder="Select Type" margin="normal" fullWidth InputLabelProps={{shrink: true}} />}
                      />
                    </Grid>
                  }
                  { mode === 'view' ?
                    <LabelValueCard md={6} label='Sub Type' value={obligation.sub_type && obligation.sub_type.label ? obligation.sub_type.label:'--'} /> :
                    <Grid item xs={12} md={6}>
                      <Autocomplete
                        options = {pltConstants.filter(item => item.type === 'obligation_sub_type')}
                        getOptionLabel={option => option.label}
                        id="sub_type"
                        value={obligation.sub_type ? obligation.sub_type:null}
                        onChange={(e, value) => {this.onFieldChange(e, 'sub_type', value);}}
                        renderInput={params => <TextField required={[5,6,7,8].includes(obligation?.obligation_type?.value)?false:true} error={error.sub_type ? true:false} helperText={error.sub_type?error.sub_type:''} onFocus={(e) => this.updateErrorField('sub_type')} {...params} label="Sub Type" placeholder="Select Sub Type" margin="normal" fullWidth InputLabelProps={{shrink: true}} />}
                      />
                    </Grid>
                  }
                  { mode === 'view' ?
                    <LabelValueCard md={6} label='Commercial Value' value={obligation.value ? obligation.value:'--'} /> :
                    <Grid item xs={12} md={6}>
                      <TextField
                        required={[5,6,7,8].includes(obligation?.obligation_type?.value)?false:true}
                        id="value"
                        label="Commercial Value"
                        fullWidth
                        margin="normal"
                        inputProps={{ maxLength: 10 }}
                        value={obligation.value ? obligation.value:''}
                        error={error.value ? true:false }
                        helperText={error.value ? error.value: ''}
                        InputLabelProps={{shrink: true}}
                        onChange={(e, value) => { regexConstants.numberWithDot.test(e.target.value) ? this.onFieldChange(e, 'value', e.target.value):e.preventDefault()}}
                        onFocus={(e) => this.updateErrorField('value')}
                        disabled={obligation.sub_type && obligation.sub_type.value === 2}
                      />
                    </Grid>
                  }

                  { mode === 'view' ?
                    <LabelValueCard md={6} xs={12} label='Details' value={obligation.details ?  ( <span dangerouslySetInnerHTML={{ __html: obligation.details.replace(/\n/g, '<br />')}}/>):'--'} /> :
                    <Grid item xs={12} md={6}>
                      <TextField
                        id="details"
                        label="Details"
                        fullWidth
                        margin="normal"
                        // inputProps={{ maxLength: 500 }}
                        // error={error.details ? true:false }
                        // helperText={error.details ? error.details: ''}
                        value={obligation.details ? obligation.details:''}
                        onChange={(e, value) => this.onFieldChange(e, 'details', e.target.value)}
                        InputLabelProps={{shrink: true}}
                        onFocus={(e) => this.updateErrorField('details', '')}
                      />
                    </Grid>
                  }

                  { mode === 'view' ?
                    <LabelValueCard md={6} label='Applicable To' value={obligation.applicable ? obligation.applicable:'--'} /> :
                    <Grid item xs={12} md={6}>
                      {(() => {
                        let options = [{label: `${jetStreamInstance?'Lessor/Holdco':'Lessor'}`,value: 'Lessor'}, {label: 'Lessee',value: 'Lessee'}, {label: 'Both',value: 'Both'}];
                        return(
                          <Autocomplete
                            options = {options}
                            getOptionLabel={option => option.label}
                            id="applicable"
                            value={obligation.applicable ? options.find((item) => item.value === obligation.applicable):null}
                            onChange={(e, value) => this.onFieldChange(e, 'applicable', value ? value.value : null)}
                            renderInput={params => <TextField required={[5,6,7].includes(obligation?.obligation_type?.value)||leshaBankInstance?false:true} error={error.applicable ? true:false } helperText={error.applicable ? error.applicable: ''} onFocus={(e) => this.updateErrorField('applicable')} {...params} label="Applicable To" placeholder="Select Applicable To" margin="normal" fullWidth InputLabelProps={{shrink: true}} />}
                          />
                        )
                      })()}
                      
                    </Grid>
                  }
                  { mode === 'view' ?
                    <LabelValueCard md={6} label='Approver' value={obligation.to_be_approved_by && obligation.to_be_approved_by.name ? obligation.to_be_approved_by.name:'--'} /> :
                    <Grid item xs={12} md={6}>
                      <Autocomplete
                        options = {approvedUser}
                        getOptionLabel={option => option.name}
                        id="to_be_approved_by"
                        value={obligation.to_be_approved_by ? obligation.to_be_approved_by:null}
                        onChange={(e, value) => {this.onFieldChange(e, 'to_be_approved_by', value);}}
                        renderInput={params => <TextField required={[5,6,7,8].includes(obligation?.obligation_type?.value)?false:true} error={error.to_be_approved_by ? true:false } helperText={error.to_be_approved_by ? error.to_be_approved_by: ''} onFocus={(e) => this.updateErrorField('to_be_approved_by')} {...params} label="Approver" placeholder="Select Approver" margin="normal" fullWidth InputLabelProps={{shrink: true}} />}
                      />
                    </Grid>
                  }
                  { mode === 'view' ?
                    <LabelValueCard md={6} label='Due Date' value={obligation.payment_due_date ? moment(obligation.payment_due_date).format(displayDateFormat):'--'} /> :
                    <Grid item xs={12} md={6}>
                      <MuiPickersUtilsProvider utils={MomentUtils}>
                        <KeyboardDatePicker
                           required={[5,6,7,8].includes(obligation?.obligation_type?.value)?false:true}                           
                           margin="normal"
                           id="payment_due_date"
                           label="Due Date"
                           format={fieldDateFormat}
                           fullWidth
                           InputLabelProps={{shrink: true}}
                           inputProps={{readOnly: true}}
                           clearable={true}
                           value={obligation.payment_due_date ? obligation.payment_due_date:null}
                           error={error.payment_due_date ? true:false }
                           helperText={error.payment_due_date ? error.payment_due_date: ''}
                           onChange={(data, value) => {this.onFieldChange(value, 'payment_due_date', moment(data).isValid()? moment(data).format(backendDateFormat):null);this.updateErrorField('payment_due_date')}}
                           onFocus={(e) => this.updateErrorField('payment_due_date')}
                           disabled={obligation.sub_type && obligation.sub_type.value === 2}
                         />
                      </MuiPickersUtilsProvider>
                    </Grid>
                  }
                  {(titanInstance||avationPlcInstance||mtInstance || leshaBankInstance)?<>
                  {mode === 'view' ?
                    <LabelValueCard md={6} label='Copies' value={obligation?.titan_extra_fields?.copies || '--'} /> :
                    <Grid item xs={12} md={6}>
                      <TextField
                        id="copies"
                        label="Copies"
                        fullWidth
                        margin="normal"
                        value={obligation?.titan_extra_fields?.copies || ''}
                        InputLabelProps={{shrink: true}}
                        onChange={(e, value) => {this.updateFormField('copies', e.target.value)}}
                      />
                    </Grid>
                  }
                  {mode === 'view' ?
                    <LabelValueCard md={6} label='Guarantor' value={obligation?.titan_extra_fields?.guarantor || '--'} /> :
                    <Grid item xs={12} md={6}>
                      <TextField
                        id="guarantor"
                        label="Guarantor"
                        fullWidth
                        margin="normal"
                        value={obligation?.titan_extra_fields?.guarantor || ''}
                        InputLabelProps={{shrink: true}}
                        onChange={e => this.updateFormField('guarantor', e.target.value)}
                      />
                    </Grid>
                  }
                  {mode === 'view' ?
                    <LabelValueCard md={6} label='Frequency' value={obligation?.titan_extra_fields?.frequency || '--'} /> :
                    <Grid item xs={12} md={6}>
                      {(() => {
                        let options = ['Annually', 'Bi-Annually', 'Quarterly', 'Monthly', 'Daily',...(avationPlcInstance||mtInstance||leshaBankInstance?['When Available']:[])];
                        return (
                          <Autocomplete
                            options={options}
                            disableClearable={true}
                            getOptionLabel={option => option}
                            name="frequency"
                            value={obligation?.titan_extra_fields?.frequency}
                            onChange={(e, value) => { this.onFieldChange(e, 'frequency', value); }}
                            renderInput={params => <TextField style={{padding:'16px 0'}} required={[5,6,7,8].includes(obligation?.obligation_type?.value)} onFocus={(e) => this.updateErrorField('frequency')} error={error.frequency ? true:false } helperText={error.frequency ? error.frequency: ''} {...params} label="Frequency " placeholder='Select Frequency' margin="normal" fullWidth InputLabelProps={{ shrink: true }} />}
                          />
                        )
                      })()}
                    </Grid>
                  }
                  {mode === 'view' ?
                    <LabelValueCard md={6} label='Required' value={obligation?.titan_extra_fields?.required || '--'} /> :
                    <Grid item xs={12} md={6}>
                      {(() => {
                        let options = ['Yes', 'No'];
                        return (
                          <Autocomplete
                            options={options}
                            disableClearable={true}
                            getOptionLabel={option => option}
                            name="required"
                            value={obligation?.titan_extra_fields?.required}
                            onChange={(e, value) => { this.onFieldChange(e, 'required', value); }}
                            renderInput={params => <TextField style={{padding:'16px 0'}} {...params} label="Required " placeholder='Select Required' margin="normal" fullWidth InputLabelProps={{ shrink: true }} />}
                          />
                        )
                      })()}
                    </Grid>
                  }
                    {titanInstance && obligation?.obligation_type?.value === 5 && <>{mode === 'view' ?
                      <LabelValueCard md={6} label='Last Financial Record' value={obligation?.titan_extra_fields?.last_financial_record || '--'} /> :
                      <Grid item xs={12} md={6}>
                        <TextField
                          id="last_financial_record"
                          label="Last Financial Record"
                          fullWidth
                          margin="normal"
                          value={obligation?.titan_extra_fields?.last_financial_record}
                          InputLabelProps={{ shrink: true }}
                          onChange={e => this.updateFormField('last_financial_record', e.target.value)}
                        />
                      </Grid>
                    }</>}
                  </> : null}
                  
                  { mode === 'view' ?
                    <LabelValueCard md={12} label='Remarks' value={obligation.remarks ? ( <span dangerouslySetInnerHTML={{ __html: obligation.remarks.replace(/\n/g, '<br />')}}/>):'--'} /> :
                    <Grid item xs={12}>
                      <TextField
                        id="remarks"
                        label="Remarks"
                        fullWidth
                        margin="normal"
                        multiline
                        rows="6"
                        // inputProps={{ maxLength: 500 }}
                        value={obligation.remarks ? obligation.remarks:''}
                        onChange={(e, value) => this.onFieldChange(e, 'remarks', e.target.value)}
                        InputLabelProps={{shrink: true}}
                      />
                    </Grid>
                  }
                  {mode === 'view' ?
                    <div style={{ marginLeft: '8px', marginBottom: '20px' }}>
                      <p style={{ fontSize: '14px', color: 'rgb(160, 160, 160)', fontFamily: "Conv_IBMPlexSans-Regular" }}>Attachment(s) {obligation?.attachments?.length>0 ? `[Count : ${obligation?.attachments?.length}]` : null}</p>
                      {obligation?.attachments?.length ? obligation?.attachments && obligation?.attachments.map((file, index) => (
                        <CustomChip
                          style={{ marginRight: '4px', marginTop: '7px' }}
                          title={file.name}
                          index={index}
                          label={file.name.substring(0, 14) + '...'}
                          onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.setState({ previewDocs: file }) }}
                        />
                      )) : '--'}
                    </div>
                    :
                    (
                      <Grid item xs={12} style={{ marginBottom: '5px' }} className='drag-drop'>
                        <p style={{ fontSize: '13px', color: 'rgb(160, 160, 160)', fontFamily: "Conv_IBMPlexSans-Regular", marginLeft: '8px' }}>Attachment(s)</p>
                        <CustomDropzone
                          onChange={(files) => this.setState({ attachedDoc: files })}
                          componentData={obligation}
                          attachedDoc = {this.state.attachedDoc}
                        >
                        </CustomDropzone>
                        {obligation?.attachments && obligation?.attachments.map((file, index) => (
                          <CustomChip
                            style={{ marginRight: '4px', marginTop: '7px' }}
                            title={file.name}
                            index={index}
                            label={file.name.substring(0, 14) + '...'}
                            onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.setState({ previewDocs: file }) }}
                            onDelete={(e) => { e.preventDefault(); e.stopPropagation(); this.setState({ deleteAttachmentModal: true, deleteItem: file }); }}
                          />
                        ))}
                      </Grid>)}
                </Grid>
              </div>
              <div className="drawer-footer">
                { mode !== 'view' ?
                  <Button onClick={this.addEditObligationFn} color="primary" variant="contained" disabled={formSubmitLoader}>
                    { formSubmitLoader ? <CircularProgress color="#ffffff" size={24} />:'Save Changes' }
                  </Button>:null
                }
                <Button onClick={() => this.setState({modal:false, mode:'', obligation:{}, error:{}})} color="primary" style={mode == 'view' ? {marginLeft:'auto', paddingLeft:'0px'}:{marginLeft:'8px'}}>Cancel</Button>
              </div>
            </div>
          </Drawer>:null
        }
         {
        this.state.previewDocs ? <PreviewDocsModal previewDocs={this.state.previewDocs} toggleModalFn={() => this.setState({ previewDocs: '' })} /> : null
      }
      {this.state.deleteAttachmentModal ?
        <DeletePopUp
          modal={this.state.deleteAttachmentModal}
          toggleModalFn={() => this.setState({ deleteAttachmentModal: false })}
          title="Delete Attachment"
          content={<h4>Are you sure you want to delete?</h4>}
          deleteRecordFn={() => deleteAttachmentApi(this.state.deleteItem,this.toggleFnc,this.getDeleteResponse)}
        /> : null
      }
      </Fragment>
    )
  }
}
export default withRouter(withSnackbar(ObligationCRU));
